import { useState, useEffect, FormEvent } from 'react';

import { useHistory } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import {
  SalesProps,
  StoreInterface,
  FirebaseSales,
  AuthorProps,
  AuthorInterface,
  ReferProps,
  ReferInterface,
  RepresentInterface,
  ProdutoInterface,
  IndividSale,
} from '../interfaces/interfaces';
import { database, storage } from '../services/firebase';
import { Sale } from '../components/Sale';
import { Store } from '../components/Store';
import { Author } from '../components/Author';
import { Reference } from '../components/Reference';
import { Repre } from '../components/Repre';
import { ReferenceTwo } from '../components/ReferenceTwo';
import { BackgroundSVG } from '../components/BackgroundSVG';
import { useAdmin } from '../hooks/useAdmin';
import { SiMicrosoftexcel } from 'react-icons/si';

import { v4 as uuidv4 } from 'uuid';

import logoCarrano from '../assets/logo.svg';
import uploadIcon from '../assets/upload-icon.svg';
import '../styles/pages-styles/adminpage.scss';

import { CSVLink } from 'react-csv';
import { IndSale } from '../components/IndSale';

export function AdminPage() {
  const [salesmar, setSalesMar] = useState<SalesProps[]>([]);
  const [stores, setStores] = useState<StoreInterface[]>([]);
  const [authors, setAuthors] = useState<AuthorProps[]>([]);
  const [reference, setReference] = useState<ReferProps[]>([]);
  const [referenceRepre, setReferenceRepre] = useState<ReferProps[]>([]);
  const [storeName, setStoreName] = useState<StoreInterface[]>([]);
  const [representantes, setRepresentantes] = useState<RepresentInterface[]>([]);

  const [storeId, setStoreId] = useState<string>('');
  const [storeTotal, setStoreTotal] = useState<number>();
  const [repreSelected, setRepreSelected] = useState<string>();

  const [cnpj, setCnpj] = useState<string>('');
  const [city, setCity] = useState<string>('');
  const [name, setName] = useState<string>('');
  const [realname, setRealname] = useState<string>('');
  const [uf, setUf] = useState<string>('');
  const [salesforce, setSalesforce] = useState<string>('');
  const [segment, setSegment] = useState<string>('Basic');

  const [repreName, setRepreName] = useState<string>('');
  const [repreMail, setRepreMail] = useState<string>('');

  const [referName, setReferName] = useState<string>('');
  const [combination, setCombination] = useState<string>('');
  const [referImage, setReferImage] = useState();
  const [image, setImage] = useState<any>();

  const [products, setProducts] = useState<ProdutoInterface[]>([]);

  const [disabled, setDisabled] = useState(false);
  const [referDisabled, setReferDisabled] = useState(false);
  const [disabledRepre, setDisabledRepre] = useState(false);

  const [individualSale, setIndividualSale] = useState<IndividSale[]>([]);

  const { admin } = useAdmin();
  const history = useHistory();

  const headersStores = [
    { label: 'Nome', key: 'name' },
    { label: 'CNPJ', key: 'cnpj' },
    { label: 'Estado', key: 'uf' },
    { label: 'Nome', key: 'name' },
    { label: 'Representante', key: 'salesforce' },
  ];
  const csvReportStores = {
    filename: 'lojas.csv',
    headers: headersStores,
    data: stores,
  };
  const headersAuthors = [
    { label: 'Vendedor', key: 'id' },
    { label: 'Pares', key: 'sales' },
    { label: 'Representante', key: 'salesforce' },
    { label: 'Loja', key: 'storeName' },
  ];
  const csvReportAuthors = {
    filename: 'vendedores.csv',
    headers: headersAuthors,
    data: authors,
  };
  const headersReference = [
    { label: 'Referência', key: 'id' },
    { label: 'Pares', key: 'sales' },
  ];
  const csvReportReference = {
    filename: 'lojas.csv',
    headers: headersReference,
    data: reference,
  };
  const headersIndSale = [
    { label: 'Loja', key: 'storeName' },
    { label: 'CNPJ', key: 'storeId' },
    { label: 'Representante', key: 'salesforce' },
    { label: 'Vendedor', key: 'authorName' },
    { label: 'Referência', key: 'refer' },
    { label: 'Data', key: 'date' },
    { label: 'Número', key: 'quant' },
    { label: 'Cor', key: 'color' },
  ];
  const csvIndividualSale = {
    filename: 'vendascarrano.csv',
    headers: headersIndSale,
    data: individualSale,
  };

  let productId = uuidv4();

  //listeners para enviar usuários não logados para a page de login
  useEffect(() => {
    if (!admin) {
      history.push('/adminlogin');
    }
  });
  //lista de vendas unitárias
  useEffect(() => {
    const saleRef = database.ref(`sale`);
    saleRef.on('value', store => {
      const databaseSale = store.val();
      const sale: IndividSale = databaseSale ?? {};
      const sales = Object.entries(sale).map(([key, value]) => {
        return {
          id: key,
          storeName: value.storeName,
          storeId: value.storeId,
          salesforce: value.salesforce,
          authorName: value.authorName,
          refer: value.refer,
          date: value.date,
          quant: value.quant,
          color: value.color,
        };
      });
      setIndividualSale(sales);
    });
  }, []);
  //lista de lojas
  useEffect(() => {
    const ref = database.ref('stores');

    ref.on('value', snapshot => {
      const databaseStore = snapshot.val();
      const firebaseStores: StoreInterface = databaseStore ?? {};

      const parsedStores = Object.entries(firebaseStores).map(([key, value]) => {
        return {
          id: key,
          name: value.dados.name,
          realname: value.dados.realname,
          city: value.dados.city,
          uf: value.dados.uf,
          cnpj: value.dados.cnpj,
          salesforce: value.dados.salesforce,
        };
      });
      setStores(parsedStores);
    });
  }, []);
  //lista de representante
  useEffect(() => {
    const ref = database.ref('representantes');

    ref.on('value', snapshot => {
      const databaseStore = snapshot.val();
      const firebaseStores: RepresentInterface = databaseStore ?? {};

      const parsedStores = Object.entries(firebaseStores).map(([key, value]) => {
        return {
          id: key,
        };
      });
      setRepresentantes(parsedStores);
    });
  }, []);
  //lista de vendas por loja selecionada
  useEffect(() => {
    if (storeId) {
      const storeRef = database.ref(`stores/${storeId}`);
      storeRef.on('value', store => {
        const databaseStore = store.val();
        const firebaseSales: FirebaseSales = databaseStore.sales ?? {};
        const parsedSales = Object.entries(firebaseSales).map(([key, value]) => {
          return {
            id: key,
            author: value.author,
            quant: value.quant,
            refer: value.refer,
            color: value.color,
            date: value.date,
          };
        });
        setSalesMar(parsedSales);
      });
    }
  }, [storeId]);
  //ranking vendedores
  useEffect(() => {
    const storeRef = database.ref(`vendor`);
    storeRef.on('value', store => {
      const databaseStore = store.val();
      const authorSales: AuthorInterface = databaseStore ?? {};
      const autho = Object.entries(authorSales).map(([key, value]) => {
        return {
          sales: Object.values(value.sales ?? {}).length,
          id: key,
          avatar: value.avatar,
          salesforce: value.salesforce,
          storeName: value.storeName,
        };
      });
      setAuthors(autho);
    });
  }, []);
  //ranking referencias
  useEffect(() => {
    const storeRef = database.ref(`styles`);
    storeRef.once('value', store => {
      const databaseStore = store.val();
      const authorSales: AuthorInterface = databaseStore ?? {};
      const refer = Object.entries(authorSales).map(([key, value]) => {
        return {
          id: key,
          sales: Object.values(value.sales ?? {}).length,
        };
      });
      setReference(refer);
    });
  }, []);
  //ranking referencias por representante
  useEffect(() => {
    const storeRef = database.ref(`representantes/${repreSelected}/styles`);
    storeRef.on('value', store => {
      const databaseStore = store.val();
      const repreSales: ReferInterface = databaseStore ?? {};
      const refer = Object.entries(repreSales).map(([key, value]) => {
        return {
          id: key,
          sales: Object.values(value.sales ?? {}).length,
        };
      });
      setReferenceRepre(refer);
    });
  }, [repreSelected]);
  //trazendo o nome da loja selecionadas
  useEffect(() => {
    if (storeId) {
      const roomRef = database.ref(`stores/${storeId}/dados`);

      roomRef.orderByChild('name').once('value', store => {
        const databaseStore = store.val().name;
        if (!databaseStore) {
          console.log('databaseStore is null');
        } else {
          setStoreName(databaseStore);
        }
      });
    }
  }, [storeId]);
  //total de pares da loja selecionada
  useEffect(() => {
    const roomRef = database.ref(`stores/${storeId}/sales`);

    roomRef.once('value', store => {
      const databaseStore = store.numChildren();
      setStoreTotal(databaseStore);
    });
  }, [storeId]);
  //lista de produtos registrados
  useEffect(() => {
    const ref = database.ref('products');

    ref.on('value', snapshot => {
      const databaseProduct = snapshot.val();
      const firebaseProducts: ProdutoInterface = databaseProduct ?? {};

      const parsedProducts = Object.entries(firebaseProducts).map(([key, value]) => {
        return {
          id: key,
          referName: value.referName,
          combination: value.combination,
          referImage: value.referImage,
        };
      });
      setProducts(parsedProducts);
    });
  }, []);

  async function handleNewStore(event: FormEvent) {
    event.preventDefault();
    setDisabled(true);
    if (salesforce === '') {
      toast.error('Selecione um representante');
    } else {
      if (cnpj.length > 14 || cnpj.length < 14) {
        toast.warning('CNPJ deve ter 14 digitos, digite somente números!');
        setCnpj('');
        setDisabled(false);
      } else {
        try {
          const store = {
            cnpj,
            city,
            name,
            realname,
            uf,
            salesforce,
            segment,
          };
          const storename = {
            name,
          };

          await database.ref(`stores/${cnpj}/dados`).set(store);
          await database.ref(`representantes/${salesforce}/lojas/${cnpj}`).set(storename);

          setCnpj('');
          setCity('');
          setName('');
          setRealname('');
          setUf('');

          toast.success('Cadastro concluído!');
          setDisabled(false);
        } catch (err) {
          toast.success('Não foi possível cadastrar a loja, favor contatar o suporte SMART');
        }
      }
    }

    setDisabled(false);
  }

  async function handleNewRepre(event: FormEvent) {
    event.preventDefault();
    setDisabledRepre(true);

    const representante = {
      repreMail,
      repreName,
    };

    try {
      await database.ref(`representantes/${repreName}`).set(representante);
      toast.success('Representante cadastrado!');
      setRepreName('');
      setRepreMail('');
      setDisabledRepre(false);
    } catch (err) {
      toast.error('Não foi possível cadastrar o representate, favor entrar em contato com o suporte SMART');
    }
    setDisabledRepre(false);
  }

  function handleUpdatePhoto() {
    const uploadTask = storage.ref(`images/${image.name}`).put(image);
    uploadTask.on(
      'state_changed',
      snapshot => {
        const progress1 = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        // setProgress(progress1);
        console.log(progress1);
      },
      error => {
        console.log(error);
      },
      () => {
        storage
          .ref('images')
          .child(image.name)
          .getDownloadURL()
          .then(url => {
            setReferImage(url);
          });
      }
    );
  }

  async function handleNewProduct(event: FormEvent) {
    event.preventDefault();
    setReferDisabled(true);

    try {
      const referNameExistsOrDont = await database.ref(`products/${referName}`).get();
      if (referNameExistsOrDont.exists()) {
        toast.error('Essa referência já existe, favor excluir previamente para cadastrar novamente!');
      } else {
        const product = {
          id: productId,
          referName,
          combination,
          referImage,
        };
        await database.ref(`products/${referName}/`).set(product);

        toast.success('Produto Cadastrado!');
        setReferName('');
        setCombination('');
      }
    } catch (err) {
      toast.error('Não foi possível cadastrar o produto! Favor entrar em contato com o suporte SMART!');
    }
    setReferDisabled(false);
  }

  function handleStoreSelected(storingId: string | undefined) {
    if (storingId) setStoreId(storingId);
  }

  function handleRepreSelected(repreId: string | undefined) {
    setRepreSelected(repreId);
  }

  const handleFileSelect = (event: any) => {
    if (event.target.files[0]) {
      setImage(event.target.files[0]);
    }
  };

  return (
    <>
      <BackgroundSVG />
      <div className="container">
        <div className="logo-container">
          <img src={logoCarrano} alt="CARRANO Logo" />
        </div>
        <h2 className="text-secondary text-regular text-center">ADMIN</h2>
        <h3>{admin?.email}</h3>
      </div>
      <div className="container-header">
        <div className="container-store5">
          <div className="container-store5-inside">
            <div className="container-store5-top">
              <span className="container-store5-inside-title">RANKING - REPRESENTANTE / REFERÊNCIAS MAIS VENDIDAS</span>
              <div className="representantesRanking">
                {representantes.map((representante: RepresentInterface) => {
                  return <Repre key={representante.id} id={representante.id} onClick={() => handleRepreSelected(representante.id)} />;
                })}
              </div>
            </div>
            {!repreSelected ? (
              <span className="container-store5-inside-reprename">Selecione um representante..</span>
            ) : (
              <span className="container-store5-inside-reprename">{repreSelected}</span>
            )}
            {!repreSelected ? (
              ''
            ) : referenceRepre.length !== 0 ? (
              referenceRepre
                .sort((a, b) => a.sales - b.sales)
                .map((repre: ReferInterface) => {
                  return <ReferenceTwo key={repre.id} id={repre.id} sales={repre.sales} />;
                })
                .reverse()
            ) : (
              <span className="container-store5-inside-reprename"> ainda não possui vendas</span>
            )}
          </div>
        </div>
        <div className="container-store2">
          <div className="container-store2-inside">
            <span className="container-store2-inside-title">RANKING DE REFERÊNCIAS</span>
            <button className="csvDownload-btn">
              <CSVLink {...csvReportReference}>
                <SiMicrosoftexcel className="csv-icon" />
              </CSVLink>
            </button>
            {reference
              .sort((a, b) => a.sales - b.sales)
              .map((refer: ReferInterface) => {
                return <Reference key={refer.id} id={refer.id} sales={refer.sales} />;
              })
              .reverse()}
          </div>
        </div>
      </div>
      <div className="container-footer">
        <div className="container-store3">
          <div className="container-store3-inside">
            <span className="container-store3-inside-title">RANKING VENDEDORES</span>
            <button className="csvDownload-btn">
              <CSVLink {...csvReportAuthors}>
                <SiMicrosoftexcel className="csv-icon" />
              </CSVLink>
            </button>
            {authors
              .sort((a, b) => a.sales - b.sales)
              .map((author: AuthorProps) => {
                return <Author key={author.id} id={author.id} sales={author.sales} avatar={author.avatar} />;
              })
              .reverse()}
          </div>
        </div>

        <div className="container-store">
          <div className="products-list-store">
            <span className="products-list-store-title">
              LISTA DE LOJAS
              <button className="csvDownload-btn">
                <CSVLink {...csvReportStores}>
                  <SiMicrosoftexcel className="csv-icon" />
                </CSVLink>
              </button>
            </span>
            {stores.map((store: StoreInterface) => {
              return <Store {...store} key={store.id} onClick={() => handleStoreSelected(store.id)} />;
            })}
          </div>
          <div className="container-store-sales">
            <div className="container-store-sales-wrapper">
              <span className="container-store-title">VENDAS DA LOJA: {storeName} </span>
              <span className="container-store-title2">TOTAL DE PARES: {storeTotal} </span>
            </div>
            {salesmar.map((sale: SalesProps) => {
              return <Sale {...sale} key={sale.id} />;
            })}
          </div>
        </div>
      </div>
      <div className="container-underfooter">
        <div className="container-store6">
          <div className="container-store6-inside">
            <span className="container-store6-inside-title">CADASTRO DE REPRESENTANTE</span>
            <form onSubmit={handleNewRepre}>
              <div className="div-inputs">
                <input
                  type="text"
                  placeholder="Nome"
                  name="id"
                  value={repreName}
                  onChange={event => setRepreName(event.target.value)}
                  minLength={3}
                  maxLength={18}
                />
                <input
                  type="email"
                  placeholder="Email do representante"
                  name="email"
                  value={repreMail}
                  onChange={event => setRepreMail(event.target.value)}
                  minLength={8}
                />
                <button className="addButton" disabled={disabledRepre || !repreName || !repreMail} type="submit">
                  <span className="addButton-icon">CADASTRAR</span>
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="container-store4">
          <div className="container-store4-inside">
            <span className="container-store4-inside-title">CADASTRO DE LOJAS</span>
            <form onSubmit={handleNewStore}>
              <div className="div-inputs">
                <input
                  type="number"
                  placeholder="CNPJ"
                  name="id"
                  value={cnpj}
                  onChange={event => setCnpj(event.target.value)}
                  maxLength={14}
                  minLength={14}
                />
                <input
                  type="text"
                  placeholder="Nome Fantasia"
                  name="name"
                  value={name}
                  onChange={event => setName(event.target.value)}
                  minLength={3}
                  maxLength={18}
                />
                <input
                  type="text"
                  placeholder="Razão Social"
                  name="realname"
                  value={realname}
                  onChange={event => setRealname(event.target.value)}
                  minLength={8}
                />
                <input
                  type="text"
                  placeholder="Cidade"
                  name="city"
                  value={city}
                  onChange={event => setCity(event.target.value)}
                  minLength={3}
                  maxLength={18}
                />
                <input
                  type="text"
                  placeholder="UF"
                  name="uf"
                  value={uf}
                  onChange={event => setUf(event.target.value)}
                  minLength={2}
                  maxLength={2}
                />
                <select placeholder="Selecione um representante" onChange={event => setSalesforce(event.target.value)}>
                  <option value="semrepresentante" disabled selected>
                    Selecione um representante
                  </option>
                  {representantes.map(option => (
                    <option value={option.id} key={option.id}>
                      {option.id}
                    </option>
                  ))}
                </select>
                <select placeholder="Selecione a segmentação" onChange={event => setSegment(event.target.value)}>
                  <option value="Basic" selected>
                    Basic
                  </option>
                  <option value="Trend">Trend</option>
                  <option value="Premium">Premium</option>
                </select>
                <button className="addButton" disabled={disabled || !cnpj || !name || !realname || !uf || !city} type="submit">
                  <span className="addButton-icon">CADASTRAR</span>
                </button>
                <ToastContainer />
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="container-underfooter">
        <div className="container-store3">
          <div className="container-store3-inside">
            <span className="container-store3-inside-title">ÚLTIMAS VENDAS</span>
            <button className="csvDownload-btn">
              <CSVLink {...csvIndividualSale}>
                <SiMicrosoftexcel className="csv-icon" />
              </CSVLink>
            </button>
            {individualSale
              .map((saleRegistered: IndividSale) => {
                return (
                  <IndSale
                    key={saleRegistered.id}
                    id={saleRegistered.id}
                    storeName={saleRegistered.storeName}
                    storeId={saleRegistered.storeId}
                    salesforce={saleRegistered.salesforce}
                    authorName={saleRegistered.authorName}
                    refer={saleRegistered.refer}
                    date={saleRegistered.date}
                    quant={saleRegistered.quant}
                    color={saleRegistered.color}
                  />
                );
              })
              .reverse()}
          </div>
        </div>
        <div className="container-store7">
          <div className="container-store7-inside">
            <span className="container-store7-inside-title">CADASTRO DE PRODUTOS</span>
            <form onSubmit={handleNewProduct}>
              <div className="div-inputs">
                <input
                  className="input-text"
                  type="text"
                  placeholder="Referência"
                  name="name"
                  value={referName}
                  onChange={event => setReferName(event.target.value)}
                  maxLength={7}
                  minLength={6}
                />
                <input
                  className="input-text"
                  type="text"
                  placeholder="Combinação"
                  name="name"
                  value={combination}
                  onChange={event => setCombination(event.target.value)}
                  minLength={3}
                  maxLength={18}
                />
                <input className="input-fileselector" type="file" onChange={handleFileSelect} name="fileSelector" id="fileSelector" />
                <div className="label-fileselector">
                  <label htmlFor="fileSelector" className="label-fileselector_left">
                    <img src={uploadIcon} alt="Carregar imagem" />
                    <p>Selecionar imagem</p>
                  </label>
                  <div className="label-fileselector_right">
                    <button className="btn-upload" type="button" onClick={handleUpdatePhoto}>
                      UPLOAD
                    </button>
                  </div>
                </div>

                <button className="addButton" disabled={referDisabled || !referName || !combination} type="submit">
                  <span className="addButton-icon">CADASTRAR</span>
                </button>
                <ToastContainer />
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
